var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopRegister(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 480,
    height: 480,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.15 294.46S-10.96 355 37.11 397.9c48.08 42.93 377.47 74.22 420.43-67.67 42.97-141.89-40.3-141.99-88.87-197.78-48.57-55.8-79.79-98.77-183.17-75.9C82.1 79.43 14.15 294.46 14.15 294.46z",
    fill: "#DAF3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M288.1 60.3c-6.32-2.78-13.05-5-20.28-6.67-.06 8.87 0 17.75.33 26.6l19.94-19.94zM270.06 112.96l38.42-41.16c-2.9-2.03-5.89-3.92-8.95-5.7l-30.5 31.24.04.86 1 14.76zM349.3 110.2l-13.95 14.26h26.4a1423.9 1423.9 0 00-12.45-14.25z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.44 110.23a20.84 20.84 0 0020.75 19.39h81.02l-9.2-10.63h-71.82c-5.33 0-9.78-4.16-10.14-9.47l-.98-14.6a549.5 549.5 0 01-1.2-40.01 118.6 118.6 0 00-10.59-2.42 562.4 562.4 0 001.18 43.14l.98 14.6z",
    fill: "#A7E3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.82 102.08h47.68c4.22 0 7.79-3.1 8.4-7.27l.3-2.11c1.45-9.99 1.54-20.13.26-30.14l-.67-5.25a8.48 8.48 0 00-8.42-7.4h-47.55a8.48 8.48 0 00-8.35 7.03 111.37 111.37 0 000 38.1 8.48 8.48 0 008.35 7.03z",
    fill: "#41C3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.66 62.62h-62.14a5.8 5.8 0 01-5.8-5.8v-5.09c0-3.2 2.6-5.8 5.8-5.8h62.14c3.2 0 5.8 2.6 5.8 5.8v5.1c0 3.2-2.6 5.8-5.8 5.8z",
    fill: "#41C3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.21 102.08h47.68c4.22 0 7.8-3.1 8.4-7.27l.3-2.11a111.4 111.4 0 00.26-30.14l-.67-5.25a8.48 8.48 0 00-8.42-7.4h-47.55a8.48 8.48 0 00-8.35 7.03 111.42 111.42 0 000 38.1 8.48 8.48 0 008.35 7.03z",
    fill: "#A7E3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M198.05 62.62h-62.14a5.8 5.8 0 01-5.8-5.8v-5.09c0-3.2 2.6-5.8 5.8-5.8h62.14c3.2 0 5.8 2.6 5.8 5.8v5.1c0 3.2-2.6 5.8-5.8 5.8z",
    fill: "#41C3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M177.4 69.94h-20.83a3.66 3.66 0 010-7.31h20.83a3.66 3.66 0 010 7.31z",
    fill: "#DAF3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.52 205.2h47.68c4.22 0 7.79-3.09 8.4-7.26l.3-2.11a111.4 111.4 0 00.26-30.14l-.67-5.25a8.48 8.48 0 00-8.42-7.4h-47.55a8.48 8.48 0 00-8.36 7.03 111.42 111.42 0 000 38.1 8.48 8.48 0 008.36 7.03z",
    fill: "#41C3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M216.36 165.75h-62.14a5.8 5.8 0 01-5.8-5.8v-5.1c0-3.2 2.6-5.79 5.8-5.79h62.14c3.2 0 5.8 2.6 5.8 5.8v5.1c0 3.2-2.6 5.79-5.8 5.79z",
    fill: "#41C3FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M147.91 205.2h47.68c4.22 0 7.79-3.09 8.4-7.26l.3-2.11c1.45-9.99 1.54-20.13.26-30.14l-.67-5.25a8.48 8.48 0 00-8.42-7.4h-47.55a8.48 8.48 0 00-8.35 7.03 111.37 111.37 0 000 38.1 8.48 8.48 0 008.35 7.03z",
    fill: "#A7E3FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M202.75 165.75H140.6a5.8 5.8 0 01-5.8-5.8v-5.1c0-3.2 2.6-5.79 5.8-5.79h62.14c3.2 0 5.8 2.6 5.8 5.8v5.1c0 3.2-2.6 5.79-5.8 5.79z",
    fill: "#41C3FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M182.1 173.07h-20.84a3.66 3.66 0 110-7.32h20.84a3.66 3.66 0 010 7.32z",
    fill: "#DAF3FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M232.7 285.18V101.8H116.57c-3.56 3.92-7.05 8-10.46 12.22h116.06v90.14H60.4v-18.84a652.28 652.28 0 00-10.62 21.15v78.7h10.62V217h161.75v68.18h10.55z",
    fill: "#A7E3FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M457.54 330.23c2.8-9.26 5.06-17.9 6.83-26.02-58.3-12.11-131-19.31-209.85-19.31-95.39 0-181.79 10.52-244.55 27.55a111.2 111.2 0 00-1.74 7.57c-2.32 21.53.7 52.72 28.89 77.88 9.45 8.45 29.82 16.43 56.72 22.75v-42.5s138.07 7.54 291.36 26.4c35.33-16.33 62.06-40.35 72.34-74.32z",
    fill: "#41C3FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.23 368.84s146.26 7.98 304.86 28.09c27.89-15.92 48.67-37.68 57.45-66.7a317.59 317.59 0 008.68-35.24c-58.37-12.17-131.25-19.4-210.3-19.4-95.4 0-181.8 10.52-244.56 27.55C6.47 321.39.1 364.85 37.11 397.9c9.62 8.6 30.52 16.71 58.12 23.08v-52.14z",
    fill: "#A7E3FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M307.95 303.14s8.88 12.78 7.55 20.1c-.88 4.81-12.25 10.84-19.96 14.41-1.7.79-1.18 3.32.69 3.4l62.12 2.72c3.95.18 7.86-1.11 10.79-3.77 5.62-5.1 12.1-15.05 1.73-29.43-15.75-21.85-62.92-7.43-62.92-7.43z",
    fill: "#0095DA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M438.1 317.61c-62.82 2.24-115.49-2.18-177.87-7.96a26.56 26.56 0 01-24.08-25.16 585.6 585.6 0 017.17-130.24c2.22-13.24 13.51-23.24 26.78-23.7 62.82-2.24 113.85-3.09 176.23 2.7l11.75 2.62c13.38 3.77 20.68 17.29 21.44 30.62 0 0 3.13 78.73-6.63 124.84-5.24 24.74-34.79 26.28-34.79 26.28z",
    fill: "#0095DA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M434.3 318.02a1517.7 1517.7 0 01-194.18-5.5 27.44 27.44 0 01-24.88-25.99A604.8 604.8 0 01222.65 152c2.3-13.68 13.95-24 27.66-24.5 64.89-2.3 129.74-.46 194.18 5.51A27.44 27.44 0 01469.37 159c2.55 44.84.07 89.97-7.41 134.53-2.3 13.68-13.95 24-27.66 24.49z",
    fill: "#41C3FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M443.03 285.68a12.33 12.33 0 0012.48-10.56 533.72 533.72 0 005.01-110.16c-.73-12.49-10.48-22.41-23.14-23.56a1449.45 1449.45 0 00-180.67-4.98c-12.75.44-23.59 9.8-25.73 22.2a535.09 535.09 0 00-7.45 109.89 12.33 12.33 0 0011.98 11.92l207.52 5.25z",
    fill: "#A7E3FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M434.98 241.53l-211.5 23.39.09 3.66c.07 1.96.63 3.77 1.5 5.39l208.26-23.64 1.65-8.8zM457.35 262.01c.25-2.01.46-4.04.68-6.05-19.96 7.17-48.82 17.57-78 28.2l21.45.54 55.87-22.69z",
    fill: "#8CDAFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M336.36 310.52a8.97 8.97 0 100-17.94 8.97 8.97 0 000 17.94z",
    fill: "#0095DA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M280 247.37l3.25-46.12s3.42-55.64 61.19-57.49c53.92 1.44 55.35 61.15 55.35 61.15l-2.24 43.6L280 247.38z",
    fill: "#41C3FF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M286.43 241.9l2.9-41.1s3.04-49.57 54.51-51.21c48.04 1.28 49.32 54.48 49.32 54.48l-2 38.86-104.73-1.03z",
    fill: "#004F74"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M301.73 202.05s3-48.59 53-51.15a56.65 56.65 0 00-10.9-1.3c-51.46 1.63-54.5 51.2-54.5 51.2l-2.9 41.1 12.48.13 2.82-39.98z",
    fill: "#0072A7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M290.55 193.26c-1.04 4.55-1.23 7.55-1.23 7.55l-2.9 41.1 12.5.12 2.81-39.98s.64-10.3 6.2-21.66a31.93 31.93 0 00-17.38 12.87z",
    fill: "#0095DA"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M198.28 242.64l.59 7.68 245.6 1.72 15.05-6.32.62-7.71",
    fill: "#0072A7"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M222.62 238.01l-24.34 4.63 246.6.7 15.26-5.33H222.62z",
    fill: "#41C3FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M74 335.08H38c-20.99 0-38-17-38-37.99v-12.22a55.99 55.99 0 0156-55.98c30.92 0 56 25.07 56 55.98v12.22a38 38 0 01-38 37.99z",
    fill: "#8CC640"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23 303.83v-12.22a55.99 55.99 0 0155.99-55.98 55.72 55.72 0 0137.9 14.87A55.85 55.85 0 0056 228.9C25.07 228.9 0 253.96 0 284.87v12.23a37.89 37.89 0 0013.46 28.98 37.8 37.8 0 01-7.23-22.25z",
    fill: "#A9DD57"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M197.68 406.84a380.28 380.28 0 01-158.72.55l-2.9-.62c-8.88-1.88-14.98-7.8-14.98-14.53v-8.8c0-6.7 6.06-12.6 14.88-14.5l1.47-.33a380.32 380.32 0 01158.68 0l1.47.32c8.82 1.9 14.88 7.8 14.88 14.52v8.9c0 6.68-6 12.57-14.78 14.49z",
    fill: "#8CC640"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.67 423.83a481.97 481.97 0 0016.2 2.87v-46.17h-16.2v43.3z",
    fill: "#0095DA"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M197.68 406.84a380.28 380.28 0 01-158.72.55l-2.9-.62c-8.88-1.88-14.98-7.8-14.98-14.53v-8.8c0-6.7 6.06-12.6 14.88-14.5l1.47-.33a380.32 380.32 0 01158.68 0l1.47.32c8.82 1.9 14.88 7.8 14.88 14.52v8.9c0 6.68-6 12.57-14.78 14.49z",
    fill: "#8CC640"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M212.46 387.1v-3.66c0-6.7-6.05-12.61-14.87-14.51l-1.47-.32a380.29 380.29 0 00-158.68 0l-1.48.32c-.93.2-1.81.47-2.68.75 2.29 7.84 9.38 18.6 29.86 26.84l2.77.58a277.25 277.25 0 0036.58 5.15c5.26 3.33 11.6 8.05 15.14 13.23 4.57-.01 9.15-.12 13.72-.29a46.33 46.33 0 00-6.77-12.24 265.4 265.4 0 0047-4.55c5.06 3.4 9.93 7.4 12.05 11.2 4.35-.78 8.69-1.62 13-2.55a219.44 219.44 0 00-11.54-11.53 253.29 253.29 0 0026.35-7.96c.36-.13.68-.31 1.02-.46z",
    fill: "#077C3F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M240 309.45c-35.07 0-45.08-33.05-45.18-33.4a4.73 4.73 0 019.08-2.65c.37 1.25 9.5 30.64 43.05 26.1 36.11-4.88 58.53-28.33 58.75-28.56a4.73 4.73 0 016.9 6.48c-1 1.06-24.97 26.13-64.38 31.46a61 61 0 01-8.22.57z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M303.13 278.64s-3.92-4.21-.34-10.23c1.67-2.81 36.24-31.67 41.62-30 5.4 1.66-11.06 19.12-11.06 19.12s6.98 10.15 5.05 17.97c-1.93 7.82-12.77 15.83-23.89 14.27-5.29-.74-11.38-11.13-11.38-11.13zM148.86 429.98c.05-2.8-.04-5.55-.34-8.16-2.76-24.11-48.4-35.76-53.6-37.01a5.9 5.9 0 10-2.76 11.49c16.52 3.99 43.24 14.8 44.62 26.86.19 1.7.25 3.5.26 5.33 3.88.53 7.81 1.03 11.82 1.5zM223.06 418.87c-2.75-24.12-48.4-35.77-53.6-37.02a5.9 5.9 0 10-2.76 11.49c13.94 3.35 43.18 14.33 44.62 26.87.48 4.22.31 8.96-.21 13.77 3.94.06 7.89.1 11.86.07.5-5.22.63-10.42.09-15.19z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M86.94 134.41c-1.21-1.96-3.14-3.06-5.54-2.35-2.4.7-3.86 2.46-3.85 4.78 0 0-8.28-2.87-5.78 1.37 1.77 2.8 4.9 5.85 6.63 7.33 0 0 9.34-1.42 12.16-2.91.9-2.59 2.04-6.57 2.25-9.28.58-4.81-5.66.67-5.87 1.06z",
    fill: "#90BC3F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M118.43 237.53l-19.96 5.22c-5.48 1.28-10.9-1.77-12.16-7.37l-15.98-63.26a11.4 11.4 0 012.25-9.28l8.28-9.73c3-3.2 7.19-4.44 11.18-2.96l11.68 4.52a9.46 9.46 0 016.24 7.11l15.98 63.27c.87 5.38-2.4 10.98-7.5 12.48z",
    fill: "url(#paint0_linear)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M105.05 143.34c-1-4.68-3.46-9.93-3.46-9.93l-12.32 9.27a5.26 5.26 0 00-4.5-1 6.24 6.24 0 00-4.58 3.33l-14.8-2.93s-.15 6.34 1.15 10.93c1 4.68 3.58 9.22 3.58 9.22l11.72-9.08c1.34 1.27 3.4 1.65 5.06 1.82 2.58-.1 4.24-2.24 5.3-4.2l14.81 2.93c-.98-.04-.95-5.69-1.96-10.36z",
    fill: "url(#paint1_linear)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M160.25 244.12l-57.4-2c-3.35-.34-6.02-2.87-6.16-6.8l1.91-58.59a6.71 6.71 0 016.67-6.27l57.41 2c3.35.34 6.02 2.88 6.15 6.81l-1.9 58.58c-.56 3.8-3.33 6.62-6.68 6.27z",
    fill: "url(#paint2_linear)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M140.32 243.69l-17.75-.74 2.13-71.57 17.75.74-2.13 71.57z",
    fill: "url(#paint3_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M159.34 159.52a6.85 6.85 0 00-2.2-2c-7.51-4.76-16.74 6.25-19.85 10.15-.95-1.05-2.11-1.7-3.4-1.66-1.28.05-2.57.1-3.9 1.15-2.88-4.45-10.63-15.76-18.5-11.46-.82.57-1.93 1.23-2.36 2.02-2.56 2.41-2.47 5.04-1.73 6.48 2.03 6.03 16.36 8.45 21.59 8.57a4.71 4.71 0 004.6 3.62 4.4 4.4 0 004.87-3.43l.3-.09c4.84-.1 19.98-.57 22.4-6.92-.04-1.32.33-3.42-1.82-6.43zm-46.38 3.7c-.77-.43-1.12-1.66-.69-2.44a3.3 3.3 0 011.33-1.06c3.12-1.58 7.68 3.04 10.87 7.41-5.58-1.34-9.48-2.51-11.5-3.9zm43.44.81c-1.07 1.97-6.64 2.95-13.2 3.89 3.42-4 8.34-8.42 11.21-6.29 1.38.26 2.11 1.7 1.99 2.4z",
    fill: "url(#paint4_linear)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M110.22 242.93l-52.53 24.41c-3.12 1.59-6.81.02-8.37-3.17l-23.96-53.62c-1.56-3.2-.03-6.96 3.1-8.54l52.52-24.4c3.13-1.59 6.82-.02 8.37 3.17l23.97 53.62a7.02 7.02 0 01-3.1 8.53z",
    fill: "url(#paint5_linear)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M92.11 251.24l-16.3 7.79-29.54-65.24 16.4-7.48 29.44 64.93z",
    fill: "url(#paint6_linear)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9 167.35c-1.07-.35-1.84-.79-3.12-.74-9.35-.9-12.18 13.2-13.28 18.5a7.55 7.55 0 00-3.64-.26 5.87 5.87 0 00-2.57 2.4c-4.72-2.91-16.23-9.14-21.65-1.9-.43.78-1.15 1.66-1.4 3.06-.94 3.59-.03 5.64 1.13 6.3 4.56 4.63 18.39-.44 23.1-2.16 1.42 1.57 3.57 2.27 5.27 1.43a5.08 5.08 0 003.07-5.21l.3-.09c4.24-2.24 17.38-9.75 17.45-16.4-.65-1.14-1.35-3.59-4.65-4.93zM32.42 191.9c-.98-.05-1.63-1.18-1.5-1.88-.1-.3.33-1.1.85-1.58 2.18-2.63 8.23-.76 12.86 1.85-5.77 1.37-10.15 2-12.2 1.6zm39.09-19.13c.3 2.23-4.49 5.96-10.26 9.65 1.48-5.08 4-11.12 7.34-10.78 1.5-.44 2.83.83 2.92 1.13z",
    fill: "url(#paint7_linear)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M53.83 200.94s-8.85 13.36-20.01 24.98a24.95 24.95 0 00-6.34 22.6c6.08 27.84 12.32 74.4 10.23 102.09a24.89 24.89 0 009.93 21.8c13.45 10.03 28.63 17.95 28.63 17.95l22.66-91.48-45.1-97.94z",
    fill: "url(#paint8_linear)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.53 213.66c9.78 28.22 28.78 95.42 15.48 161.41-1.38 6.82 2.64 13.6 9.26 15.3 43.03 11.02 100.35 1.43 121-2.7a12.75 12.75 0 009.88-9.64c6-25.53 20.72-108.05-18.53-181.09a12.82 12.82 0 00-9.93-6.82c-16.47-1.7-62.27-4.7-117.57 6.45a13.02 13.02 0 00-9.59 17.09z",
    fill: "url(#paint9_linear)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.63 231a2.16 2.16 0 01-1.51-.77 2.26 2.26 0 01.22-3.14c.44-.38 10.81-9.34 23-2.75a2.26 2.26 0 01.9 3.02 2.16 2.16 0 01-2.95.93c-9.5-5.14-17.74 1.88-18.09 2.19-.45.4-1.02.57-1.57.53zM157.6 225.03a2.04 2.04 0 01-1.4-.72 2.12 2.12 0 01.2-2.94c.4-.36 10.1-8.73 21.48-2.57 1 .54 1.38 1.8.85 2.83a2.02 2.02 0 01-2.76.86c-8.94-4.84-16.81 1.97-16.9 2.04-.42.37-.95.54-1.47.5z",
    fill: "#004F74"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M98.14 290.06c2.58-7.74 11.77-11.99 23.4-7.95 15.86 5.48 39.96-.72 50.25-6.55 4.75-2.69 10.87-1.6 14.22 1.65 5.6 5.4 6.4 16.49 1.59 23.83-6.02 9.2-30 14.18-42.29 15.04-24.56 1.71-55.42-1.35-47.17-26.02z",
    fill: "url(#paint10_linear)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M174.62 284.7s3.6-2.09-1.04-9.95c-.62.22-1.21.48-1.79.81-10.29 5.83-34.39 12.03-50.24 6.55a25.78 25.78 0 00-9.39-1.52c-.8 2.1-2.09 6.42.12 8.52 2.98 2.84 38.77 7.68 62.34-4.42z",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M107.11 311.99c9.79 4.54 24.91 5.01 38.2 4.09 5.58-.39 13.57-1.64 21.2-3.74-4.04-8.37-15.47-14.59-29.12-14.92-14.23-.34-26.35 5.83-30.28 14.57z",
    fill: "url(#paint11_linear)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M127.09 327.3s23.7 1.56 38.96-3.53c-9.1 13.27-32.86 9.74-38.96 3.53z",
    fill: "#004F74"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M112.26 257.68a7.23 7.23 0 007-7.46 7.23 7.23 0 00-7.3-7.14 7.23 7.23 0 00-7 7.45 7.23 7.23 0 007.3 7.15z",
    fill: "#004F74"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M108.72 254.68a4.04 4.04 0 003.92-4.17 4.04 4.04 0 00-4.1-4 4.04 4.04 0 00-3.9 4.17 4.04 4.04 0 004.08 4z",
    fill: "#fff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M170.44 251.15a7.23 7.23 0 007-7.45 7.23 7.23 0 00-7.31-7.15 7.23 7.23 0 00-7 7.45 7.23 7.23 0 007.31 7.15z",
    fill: "#004F74"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M165.93 248.93a4.04 4.04 0 003.91-4.17 4.04 4.04 0 00-4.08-4 4.04 4.04 0 00-3.92 4.17 4.04 4.04 0 004.09 4z",
    fill: "#fff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M165.84 346.3l48.29-13.46s0 39.16-5.32 49.7c-5.3 10.56-74.74 15.2-74.74 15.2s-44.08.17-64.56-8.39c-20.47-8.56-32-21.34-31.9-23.57.09-2.23-2.12-25.77.46-31.7 10.05 3.2 65.67 15.75 65.67 15.75l35.87-5.13 16.05 6.25 10.18-4.66z",
    fill: "#FCB70B"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6 365.78c-.08 2.23 11.44 15.01 31.92 23.58l.29.1c-4.6-6.32-4.84-16.66-2.83-22.9 1.84-5.71 3.2-17.31 3.9-24.29-14-3.28-28.2-6.71-32.8-8.17-2.59 5.91-.38 29.45-.47 31.68z",
    fill: "#F37021"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.74 324.77L71.4 336.6l68.2 8.1-6.13 30.3-63.29-26.17-32.08-11.45s-7.09-8.51-.37-12.6zM165.84 346.3l10.7 27.23 39.69-31.84 2.85-15.7-53.25 20.3z",
    fill: "#FFDA7D"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M139.61 344.7l26.22 1.6-13.75 18.07-12.47-19.67z",
    fill: "#F37021"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M38.11 337.37l31.9 11.4 1.4-12.18-33.67-11.82c-6.72 4.09.37 12.6.37 12.6z",
    fill: "#FCB70B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M93.36 368.76c-3.45 0-7.07-.3-10.86-.94-35.47-6.05-40.64-47.37-38.42-68.38a4.74 4.74 0 019.41.99 92.62 92.62 0 002.03 27.65C59.8 345.76 69.42 356 84.1 358.5c36.69 6.26 54.57-26.37 54.75-26.7a4.73 4.73 0 018.34 4.46c-.19.35-17.8 32.5-53.82 32.5z",
    fill: "#fff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M139.56 338.85s-3.76-4.09-.28-9.87c1.64-2.7 35.14-30.31 40.32-28.68 5.19 1.64-10.78 18.38-10.78 18.38s6.67 9.83 4.76 17.36c-1.9 7.52-12.41 15.19-23.12 13.62-5.1-.75-10.9-10.81-10.9-10.81z",
    fill: "#fff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M252.7 350l-15.03 15.52a2.46 2.46 0 001.45 4.27l119.3 11.25c4.19.35 8.3-1.28 11.08-4.41l14.27-16a4.11 4.11 0 00-2.82-6.85l-118.43-7.26a13.34 13.34 0 00-9.82 3.49z",
    fill: "#41C3FF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M255.17 356.4l7.22.46 4.85-5.12-7.64-.46-4.43 5.11zM267.73 357.2l7.24.46 4.98-5.17-7.66-.45-4.56 5.16zM254.35 365.35l4.86-5.13-6.91-.52-4.45 5.13 6.5.52zM271.63 361.13l-6.93-.5-4.57 5.17 6.5.51 5-5.18zM280.3 358l7.26.47 5.12-5.22-7.69-.46-4.7 5.21zM330.92 355.52l-7.77-.46-5.1 5.37 7.32.47 5.55-5.38zM305.45 359.62l7.3.47 5.4-5.33-7.73-.46-4.97 5.32zM284.05 362.05l-6.94-.51-4.7 5.23 6.51.51 5.13-5.23zM292.87 358.81l7.28.47 5.26-5.27-7.71-.46-4.83 5.26zM308.9 363.9l-6.96-.52-4.97 5.32 6.53.52 5.4-5.33zM296.47 362.98l-6.95-.52-4.83 5.28 6.52.5 5.26-5.26zM333.84 371.6l9.16.73 5.5-5.5-9.27-.7-5.39 5.48zM348.64 356.57l-5.38 5.48 8.6.55 5.5-5.5-8.72-.53zM335.9 355.82l-5.25 5.42 7.34.47 5.7-5.43-7.8-.46zM321.33 364.81l-6.96-.51-5.11 5.37 6.54.52 5.53-5.38zM333.77 365.74l-6.97-.52-5.25 5.42 6.54.52 5.68-5.42zM356.4 363.54l-8.8 9.39 13.19 1.2 7.8-9.6-12.2-1zM361.28 357.8l-3.43 3.7 11.8.96 3.4-3.74-11.77-.92z",
    fill: "#A7E3FF"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M393.56 383.1c2.78 1.38 6.1 1.2 8.94-.05 6.86-3.02 20.76-10.25 22.11-19.8 1.81-12.75-15.26-8.5-19.82-6.24-8.87 4.4-22.4 20.54-11.23 26.09z",
    fill: "#41C3FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 94.67,
    y1: 160.58,
    x2: 111.74,
    y2: 227.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#89C340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6FA329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 82.99,
    y1: 142.65,
    x2: 85.47,
    y2: 152.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04AE59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#047B35"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 133.72,
    y1: 176.53,
    x2: 131.65,
    y2: 239.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E90089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4007C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 132.62,
    y1: 160.48,
    x2: 130.28,
    y2: 232.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4901E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 133.98,
    y1: 164.59,
    x2: 134.24,
    y2: 176.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4901E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 56.85,
    y1: 193.85,
    x2: 83.78,
    y2: 252.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4901E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA5F01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 61.02,
    y1: 177.59,
    x2: 90.69,
    y2: 242.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 49.09,
    y1: 184.89,
    x2: 51.55,
    y2: 173.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 68.58,
    y1: 238.78,
    x2: 23.39,
    y2: 305.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3EBDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B75C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 168.49,
    y1: 203.45,
    x2: 83.68,
    y2: 327.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74D3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0EB3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 146.08,
    y1: 292.23,
    x2: 144.58,
    y2: 300.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0095DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0072A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 142.91,
    y1: 306.1,
    x2: 138.3,
    y2: 316.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA1D25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A80000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopRegister);
export default __webpack_public_path__ + "static/media/desktop-register.2d37abcc53f50c9fd5b5f8ca92f69cd5.svg";
export { ForwardRef as ReactComponent };